import {
  makeStyles,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  tokens,
} from "@fluentui/react-components";
import { useSearchParams } from "react-router-dom";

const useClasses = makeStyles({
  tabs: {
    paddingBottom: tokens.spacingVerticalL,
  },
});

export interface TabViewInfo {
  value: string;
  text: string;
}

interface TabViewProps {
  tabInfos: TabViewInfo[];
  onTabChange: (value: string) => void;
  defaultTabValue: string;
  defaultSortField?: string;
  sortAscending?: boolean;
}

export const TabView = (props: TabViewProps) => {
  const {
    tabInfos,
    onTabChange,
    defaultTabValue,
    defaultSortField,
    sortAscending,
  } = props;
  const classes = useClasses();

  const [searchParams, setSearchParams] = useSearchParams();

  const onTabSelect = (
    _event: SelectTabEvent<HTMLElement>,
    data: SelectTabData
  ) => {
    const value = data.value as string;
    const nextSearchParams = new URLSearchParams(searchParams);

    nextSearchParams.delete("page");
    nextSearchParams.delete("query");
    nextSearchParams.delete("filters");

    if (defaultSortField) {
      nextSearchParams.set("sortBy", defaultSortField);

      if (sortAscending) {
        nextSearchParams.set("sortDir", "asc");
      } else {
        nextSearchParams.set("sortDir", "desc");
      }
    } else {
      nextSearchParams.delete("sortBy");
      nextSearchParams.delete("sortDir");
    }

    nextSearchParams.set("view", value);

    setSearchParams(nextSearchParams, {
      preventScrollReset: true,
    });

    onTabChange(value);
  };

  return (
    <div className={classes.tabs}>
      <TabList
        size="large"
        selectedValue={defaultTabValue}
        onTabSelect={onTabSelect}
      >
        {tabInfos.map((tabInfo) => (
          <Tab key={tabInfo.value} value={tabInfo.value}>
            {tabInfo.text}
          </Tab>
        ))}
      </TabList>
    </div>
  );
};
